import { jsx as _jsx } from "react/jsx-runtime";
import { getPrimaryMemberCard } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useMemberContext } from '../../../context/member/hooks/use-member-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { Detail, DetailSkeleton } from '../../../subcomponents/detail/detail';
import { HeadingLevel } from '../../../subcomponents/heading/heading';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { defaultMemberCardNumberProps, memberCardNumberPropsValidator } from './types/props';
const b = bemClassBuilder('v-member-card-number');
export const MemberCardNumber = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { displayText } = props;
    const { member } = useMemberContext();
    if (!member)
        return enableSkeletonLoadingIndicators ? _jsx(MemberCardNumberSkeleton, {}) : null;
    const primaryCard = getPrimaryMemberCard();
    if (!primaryCard)
        return null;
    return (_jsx(Detail, { className: b.block(), headingLevel: HeadingLevel.H3, heading: displayText.label, content: primaryCard.cardNumber }));
});
MemberCardNumber.displayName = 'MemberCardNumber';
export const MemberCardNumberSkeleton = () => _jsx(DetailSkeleton, { className: b.block({ skeleton: true }) });
MemberCardNumberSkeleton.displayName = 'MemberCardNumberSkeleton';
/**
 * The **Member Card Number** component renders the currently logged-in Loyalty member's primary card number.
 *
 * If the currently logged-in member does not have a primary card, the **Member Card Number** component will not render.
 */
export const MemberCardNumberComponent = withComponentWrapper(MemberCardNumber, defaultMemberCardNumberProps, memberCardNumberPropsValidator);
